import { types } from 'mobx-state-tree'
import Router from "next/router"
import { ToastStore } from './ui/toastStore'

export const UIStore = types
  .model('UIStore', {
    currentHost: types.maybeNull(types.string),
    isMobile: false,
    isTablet: false,
    isSmallDesktop: false,
    isMobileMenuOpen: false,
    isWebkit: false,
    toasts: ToastStore,
    loginModalShowing: false,
    signupModalShowing: false,
    phoneVerifyModalShowing: false,
  })
  .actions(self => {
    return {
      setMobile(isMobileBool) {
        self.isMobile = isMobileBool
      },
      setTablet(isTabletBool) {
        self.isTablet = isTabletBool
      },
      setSmallDesktop(isSmallDesktopBool) {
        self.isSmallDesktop = isSmallDesktopBool
      },
      setCurrentHost(currentHost) {
        self.currentHost = currentHost
      },
      setIsMobileMenuOpen(isMobileMenuOpenBool) {
        self.isMobileMenuOpen = isMobileMenuOpenBool
      },
      setWebkit(isWebkitBool) {
        self.isWebkit = isWebkitBool
      },
      setLoginModalShowing(loginModalShowing) {
        self.loginModalShowing = loginModalShowing
      },
      setSignupModalShowing(signupModalShowing) {
        self.signupModalShowing = signupModalShowing
      },
      setPhoneVerifyModalShowing(phoneVerifyModalShowing) {
        self.phoneVerifyModalShowing = phoneVerifyModalShowing
      },
    }
  })
  .views(self => ({
    get isPayNYCFlow() {
      return Boolean(self.currentHost && self.currentHost.includes("paynyctickets.com"))
    },
    get usePasswordlessLogin() {
      if (self.currentHost && self.currentHost.includes('paynyctickets.com')) {
        return true
      }
      if (process.env.USE_PASSWORDLESS_LOGIN === 'true') {
        return true
      }
      // Vercel preview deploys (login-flow QA) — not production appwinit.com
      if (self.currentHost && self.currentHost.includes('vercel.app')) {
        return true
      }
      if (typeof window !== 'undefined') {
        return Router.pathname === '/parking/pay' || Router.pathname.startsWith('/parking/pay/')
      }
      return false
    },
    get isTrafficFlow() {
        if (typeof window !== 'undefined') {
            return Router.pathname.includes('traffic') // Traffic Lookup or Traffic Manual Submission flows
        }
        return false
    }
  }))
